"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvitationRequests = void 0;
const Requests_1 = require("../../Requests");
class InvitationRequests extends Requests_1.Requests {
    constructor() {
        super(...arguments);
        this.resource = "invite";
    }
    invite(uuid, data) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return yield this.create({
                    profile: uuid,
                    email: data.email,
                    role: data.role,
                });
            }
            catch (e) {
                throw new Error("Invite sending failed");
            }
        });
    }
}
exports.InvitationRequests = InvitationRequests;
//# sourceMappingURL=InvitationRequests.js.map